export const valuationStatus = {
  0: 'Na fila',
  1: 'Processando',
  2: 'Concluído',
  3: 'Falha',
  'Na fila': 0,
  Processando: 1,
  Concluído: 2,
  Falha: 3,
}
